/**
 * The type of each environment the Infrastructure flow offers. `getEnvironments` returns an id and a label only, so the type is
 * read from the id here, and nowhere else. The backend mirrors this map (apps/infrastructure/config/catalog.py) and derives the
 * type itself: a type sent by the page is never trusted.
 */
export type EnvironmentType = 'production' | 'staging' | 'demo'

export const ENVIRONMENT_TYPE_MAP: Readonly<Record<string, EnvironmentType>> = Object.freeze({
  production: 'production',
  stg: 'staging',
  demo: 'demo',
})

/** The type of an environment, or null when none is chosen or the environment has no type. */
export function environmentTypeOf(environment: { id: string } | null | undefined): EnvironmentType | null {
  // Own keys only: an id such as "constructor" must not find something on the object's prototype.
  return environment && Object.hasOwn(ENVIRONMENT_TYPE_MAP, environment.id) ? ENVIRONMENT_TYPE_MAP[environment.id] : null
}
